import ApiService from "@/api/apiService";
import {LocalizedDate} from "@/utils/date-utils";

export enum NotificationStatus {
  READY = 'ready',
  READY_SCHEDULED = 'ready_scheduled',
  READY_RESCHEDULED = 'ready_rescheduled',
  SENT_CARRIER = 'sent_carrier',
  SENT_USER = 'sent_user',
  RECEIVED = 'received',
  OPENED = 'opened',
  CARRIER_FAIL = 'fail_carrier',
}

export const NotificationStatusText: Record<NotificationStatus, string> = {
  [NotificationStatus.READY]: 'Ready',
  [NotificationStatus.READY_SCHEDULED]: 'Ready scheduled',
  [NotificationStatus.READY_RESCHEDULED]: 'Ready rescheduled',
  [NotificationStatus.SENT_CARRIER]: 'Sent carrier',
  [NotificationStatus.SENT_USER]: 'Sent user',
  [NotificationStatus.RECEIVED]: 'Received',
  [NotificationStatus.OPENED]: 'Opened',
  [NotificationStatus.CARRIER_FAIL]: 'Carrier fail',
}

export enum NotificationType {
  SMS = 'sms',
  EMAIL = 'mail',
}

export const NotificationTypeText: Record<NotificationType, string> = {
  [NotificationType.SMS]: 'SMS',
  [NotificationType.EMAIL]: 'Email',
}

export enum ContentTypeType {
  CONTENT_TYPE_REGISTER = 'register',
  CONTENT_TYPE_SERIAL_LINK = 'serial_link',
  CONTENT_TYPE_SERIAL_LINK_ADMIN = 'serial_link_admin',
  CONTENT_TYPE_UPDATE_CREDENTIAL = 'update_credential',
  CONTENT_TYPE_TEST = 'test',
  CONTENT_TYPE_UNKNOWN = 'unknown',
}

export const ContentTypeText: Record<ContentTypeType, string> = {
  [ContentTypeType.CONTENT_TYPE_REGISTER]: 'register',
  [ContentTypeType.CONTENT_TYPE_SERIAL_LINK]: 'serial_link',
  [ContentTypeType.CONTENT_TYPE_SERIAL_LINK_ADMIN]: 'serial_link_admin',
  [ContentTypeType.CONTENT_TYPE_UPDATE_CREDENTIAL]: 'update_credential',
  [ContentTypeType.CONTENT_TYPE_TEST]: 'test',
  [ContentTypeType.CONTENT_TYPE_UNKNOWN]: 'unknown',
}

export interface Notification {
  id: number;
  serial: NotificationSerial;
  history: NotificationHistory[];
  creationDate: string;
  lastCheck: string | null;
  nextCheck: string | null;
  status: NotificationStatus;
  type: NotificationType | null;
  provider: string | null;
  externalId: string | null;
  contentType: ContentTypeType | null;
  user: NotificationUser;
  target: string | null;
  countryCode: string | null;
  locale: string | null;
  timezone: string | null;
}

export interface NotificationHistory {
  id: number;
  status: NotificationStatus;
  creationDate: string;
}

export interface NotificationSerial {
  serialNumber: string;
  localizedCreationDate: LocalizedDate;
}

export interface NotificationUser {
  id: string;
}

interface GetNotificationListApiResponse {
  "hydra:totalItems": number;
  "hydra:member": Notification[];
}

export function getNotification(notificationId: number): Promise<Notification> {
  return ApiService.api.get(`/admin/notifications/${notificationId}`).then(r => r.data);
}

export function getNotificationsList(parametersArray: string[] = []): Promise<GetNotificationListApiResponse> {
  return ApiService.api.get(`/admin/notifications${parametersArray.join('')}`).then(r => r.data);
}
